import { ref } from '@vue/composition-api'
import { getSchoolSettings, putSchoolSettings } from '@/api'
import store from '@/store'

const schoolSettings = ref({
  defaultDatingMethod: 'terms',
})
// The settingsLoaded is used to determine if this property has been loaded already
// to avoid duplicate loads
const settingsLoaded = ref(false)

export default function useSchoolSettings ({ school = store.getters.school } = {}) {
  async function getSettings () {
    const settings = await getSchoolSettings({ school })
    if (settings) schoolSettings.value = settings
    settingsLoaded.value = true
  }

  async function updateSettings (settings) {
    store.dispatch('setCurrentPut', 'putSchoolSettings')
    schoolSettings.value = settings
    await putSchoolSettings({ school }, settings)
    store.dispatch('unsetCurrentPut', 'putSchoolSettings')
  }

  return {
    getSettings,
    settingsLoaded,
    updateSettings,
    schoolSettings,
  }
}
